
export default {
    state: { items: null },
    mutations: {
        setMailTemplates (state, items) {
            state.items = items;
        },
    }
};
